<template lang="pug">
.rich-text-wrapper
  ValidationProvider(name="Optionale Vertragsbeschreibung" :rules="rules" v-slot="{ errors, valid }")
    b-field(label="Optionale Vertragsbeschreibung" label-position="on-border"
            :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
      b-input(v-model="innerValue" type="textarea" maxlength="3000")
</template>

<script>
export default {
  props: {
    rules: {
      type: [Object, String],
      default: ""
    },
    value: {
      type: null
    }
  },
  data() {
    return {
      innerValue: ""
    };
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.rich-text-wrapper {
  margin: $sm-space 0 $xs-space 0;
}
</style>